// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"input_searchInput__1NrHc","textarea":"input_textarea__1P-ZO","commonInput":"input_commonInput__1LaSf","fullWidth":"input_fullWidth__MLvd8"};